import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/vercel/path0/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_BqLkNUef68 from "/vercel/path0/node_modules/@nuxtjs/algolia/dist/runtime/plugin.mjs";
import plugin_jBToDIZpFa from "/vercel/path0/node_modules/nuxt-graphql-client/dist/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import fathom_client_6QHXGUB7wS from "/vercel/path0/plugins/fathom.client.js";
import gsap_qE0fizvEy0 from "/vercel/path0/plugins/gsap.ts";
import inlineUtils_mS4ZLogVwO from "/vercel/path0/plugins/inlineUtils.ts";
import live_preview_rAaFLcR04D from "/vercel/path0/plugins/live-preview.js";
import multiselect_7UfRqGoZcC from "/vercel/path0/plugins/multiselect.js";
import nuxtClientInit_client_1Jw4uca8Oi from "/vercel/path0/plugins/nuxtClientInit.client.ts";
import onError_GBuFIufoYZ from "/vercel/path0/plugins/onError.ts";
import removePTags_NNOtr2gdeF from "/vercel/path0/plugins/removePTags.ts";
import sentry_client_GoGQuZo4Et from "/vercel/path0/plugins/sentry.client.js";
import veeValidate_nOzy97eFIK from "/vercel/path0/plugins/veeValidate.js";
import vue_cloudinary_image_AN6cd3OYHt from "/vercel/path0/plugins/vue-cloudinary-image.js";
import vue_gtag_client_fbnXi0Aqdd from "/vercel/path0/plugins/vue-gtag.client.js";
import vue3_popper_client_d53GxV7ExF from "/vercel/path0/plugins/vue3-popper.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_BqLkNUef68,
  plugin_jBToDIZpFa,
  i18n_yfWm7jX06p,
  fathom_client_6QHXGUB7wS,
  gsap_qE0fizvEy0,
  inlineUtils_mS4ZLogVwO,
  live_preview_rAaFLcR04D,
  multiselect_7UfRqGoZcC,
  nuxtClientInit_client_1Jw4uca8Oi,
  onError_GBuFIufoYZ,
  removePTags_NNOtr2gdeF,
  sentry_client_GoGQuZo4Et,
  veeValidate_nOzy97eFIK,
  vue_cloudinary_image_AN6cd3OYHt,
  vue_gtag_client_fbnXi0Aqdd,
  vue3_popper_client_d53GxV7ExF
]